
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import MapPage from './pages/Map/Map';
import RecordDetail from './pages/RecordDetail/RecordDetail';
import Summary from './pages/Summary/Summary';
import { useEffect, useState } from 'react';
import { GlobalStateContext } from './store/GlobalState';
import ChangePasswordPage from './pages/ChangePasswordPage';
import MaintenanceRecord from './pages/Summary/MaintenanceRecord';
import LatestPhotoRecord from './pages/RecordDetail/LatestPhotoRecord';
import Account from './pages/Account/Account';
import ResetPasswordPage from './pages/ResetPasswordPage';

interface DecodedToken {
  Role: string;
  exp?: number;
}

function App() {
  const [refreshToken, setRefreshToken] = useState("")
  const [accessToken, setAccessToken] = useState("")
  const [expires, setExpires] = useState("")
  const [user, setUser] = useState("")
  const [userRole, setUserRole] = useState<string | null>(null);

  let globalState = {
    refreshToken: refreshToken,
    setRefreshToken: setRefreshToken,
    accessToken: accessToken,
    setAccessToken: setAccessToken,
    expires: expires,
    setExpires: setExpires,
    user: user,
    setUser: setUser,
  }

  const isLoggedIn = localStorage.accessToken || globalState.accessToken;

  const decodeJWT = (token: string): DecodedToken | null => {
    try {
      const base64Url = token.split('.')[1]; // Get payload (second part)
      if (!base64Url) throw new Error('Invalid token format');

      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/'); // Convert Base64Url7 to Base64
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      return JSON.parse(jsonPayload) as DecodedToken;
    } catch (error) {
      console.error('Error decoding JWT:', error);
      return null;
    }
  };

  useEffect(() => {
    const token = localStorage.accessToken;

    if (token) {
      try {
        // Decode the JWT
        const decoded = decodeJWT(token);
        if (decoded) {
          setUserRole(decoded.Role); // Extract the role
          localStorage.setItem('role', decoded.Role);
        }
      } catch (error) {
        console.error('Invalid JWT:', error);
      }
    }
  }, []);

  return (
    <GlobalStateContext.Provider value={globalState}>
      {/* <Router> */}

      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        {isLoggedIn && (
          <>
            <Route path="/change-password" element={<ChangePasswordPage />} />
            {/* <Route path="/entry-location" element={<EntryLocationPage />} /> */}
            <Route path="/map" element={<MapPage />} />
            <Route path="/recordDetail" element={<RecordDetail />} />
            <Route path="/recordDetail/latest" element={<LatestPhotoRecord />} />
            <Route path="/summary" element={<Summary />} />
            <Route path="/summary/maintenanceRecord/:id" element={<MaintenanceRecord />} />
            {localStorage.getItem('role') === 'Admin' && <Route path="/account" element={<Account />} />}

            <Route path="*" element={<Login />} />
          </>)
        }
      </Routes>
      {/* </Router> */}
    </GlobalStateContext.Provider>
  );
}

export default App;
